/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ShopifyFieldMappingDtoBase
 * auto generated base class for the model ShopifyFieldMappingDtoModel.
 */
export const ShopifyFieldMappingDtoModelBase = ModelBase
  .named('ShopifyFieldMappingDto')
  .props({
    __typename: types.optional(types.literal("ShopifyFieldMappingDto"), "ShopifyFieldMappingDto"),
    routificField: types.union(types.undefined, types.string),
    shopifyFields: types.union(types.undefined, types.array(types.string)),
    isCustom: types.union(types.undefined, types.null, types.boolean),
    label: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyFieldMappingDtoModelSelector extends QueryBuilder {
  get routificField() { return this.__attr(`routificField`) }
  get shopifyFields() { return this.__attr(`shopifyFields`) }
  get isCustom() { return this.__attr(`isCustom`) }
  get label() { return this.__attr(`label`) }
}
export function selectFromShopifyFieldMappingDto() {
  return new ShopifyFieldMappingDtoModelSelector()
}

export const shopifyFieldMappingDtoModelPrimitives = selectFromShopifyFieldMappingDto().routificField.shopifyFields.isCustom.label
